@if (text) {
  <button
    *appPermission="permission"
    class="a-tcmrActionButton__button py-2 px-6 rounded disabled:opacity-50"
    [ngClass]="getClass()"
    [disabled]="disabled"
    (click)="onClick()"
  >
    {{ getText() | transloco }}
  </button>
} @else {
  @if (this.plain) {
    <button
      *appPermission="permission"
      class="disabled:opacity-50"
      [disabled]="disabled"
      [ngClass]="getClass()"
      (click)="onClick()"
    >
      <mat-icon [matTooltip]="getTooltip()">{{ icon }}</mat-icon>
    </button>
  } @else {
    <button
      *appPermission="permission"
      class="a-tcmrActionButton__button pt-2 pb-px px-6 rounded disabled:opacity-50"
      [ngClass]="getClass()"
      [disabled]="disabled"
      (click)="onClick()"
    >
      <mat-icon>{{ icon }}</mat-icon>
    </button>
  }
}
